import styled from '@emotion/styled';

import { ReactComponent as Esports } from '@icons/pencil-paintings/esports-is-everyones-thing.svg';
import { ReactComponent as Gamepad } from '@icons/pencil-paintings/gamepad.svg';
import { ReactComponent as NotWelcome } from '@icons/pencil-paintings/not-welcome.svg';
import { illustrationsBase } from '@styles/mixins/illustrations';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const StyledGamepad = styled(Gamepad)`
  ${illustrationsBase}
  width: 314px;
  right: calc(-1 * var(--side-field-size));
  bottom: 90px;
  transform: matrix(-1, 0, 0, 1, 0, 0);

  ${getMediaqueryStyled('xl')} {
    bottom: 120px;
    width: 291px;
  }

  ${getMediaqueryStyled('lg')} {
    bottom: 90px;
    width: 258px;
  }

  ${getMediaqueryStyled('md')} {
    right: auto;
    left: -33px;
    bottom: 80px;
    width: 220px;
    transform: none;
  }

  ${getMediaqueryStyled('sm')} {
    width: 176px;
    height: 165px;
  }
`;

export const StyledNotWelcome = styled(NotWelcome)`
  ${illustrationsBase}
  right: 345px;
  bottom: 100px;

  ${getMediaqueryStyled('xl')} {
    right: 270px;
  }

  ${getMediaqueryStyled('lg')} {
    right: 235px;
    width: 107px;
  }

  ${getMediaqueryStyled('md')} {
    right: auto;
    left: 200px;
    bottom: 85px;
    width: 123px;
  }

  ${getMediaqueryStyled('sm')} {
    left: 150px;
    bottom: 88px;
    width: 98px;
  }
`;

export const StyledEsports = styled(Esports)`
  ${illustrationsBase}
  left: 260px;
  bottom: 55px;

  ${getMediaqueryStyled('xl')} {
    left: 245px;
    bottom: 85px;
  }

  ${getMediaqueryStyled('lg')} {
    left: 140px;
    bottom: 150px;
    width: 195px;
  }

  ${getMediaqueryStyled('md')} {
    left: auto;
    right: 30px;
    bottom: 125px;
    width: 170px;
  }

  ${getMediaqueryStyled('sm')} {
    right: 10px;
    bottom: 155px;
    width: 136px;
  }
`;
